import type { InputHTMLAttributes, Ref } from 'react'

import { cn } from '@moment/design-system-ui/lib/cn'

import { getInputStyles } from '#components/controls/input'

interface MagicAuthFieldProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'maxLength'> {
  ref?: Ref<HTMLInputElement>
  hasError?: boolean
  disabled?: boolean
}

export const MagicAuthField = ({
  ref,
  hasError,
  disabled,
  className,
  ...props
}: MagicAuthFieldProps) => {
  return (
    <input
      ref={ref}
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      maxLength={6} // Allow paste of full code
      autoComplete="one-time-code"
      className={cn(
        // Base layout and sizing - specific to magic auth inputs
        'w-full h-15',
        'pt-3.25 pb-2.25',
        'text-center text-[length:var(--text-lg)] font-[number:var(--font-weight-medium)]',

        // Shared input styles
        getInputStyles({ disabled, hasError, className }),
      )}
      autoCorrect="off"
      spellCheck="false"
      data-private
      disabled={disabled}
      {...props}
    />
  )
}
